import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!user) {
        sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
        return <Navigate to="/auth" replace />;
    }

    return children;
};

export default ProtectedRoute;
